import { MaintenanceAlert } from "components/common";
import { NLKSearch } from "components/search";

const NLKPage = () => {
  return (
    <>
      <MaintenanceAlert />
      <NLKSearch />
    </>
  );
};

export default NLKPage;
